// @ts-nocheck
import throwErrorIfTesting from "@insite/client-framework/Common/ThrowErrorIfTesting";
import { ApiHandler, createHandlerChainRunner, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import { AddProductApiParameter, addQuoteWithResult } from "@store/Framework/Services/CartService";

export type AddToCartParameter = {
    onError?: (error: string) => void;
} & AddProductApiParameter &
    HasOnSuccess<CartLineModel>;

type HandlerType = ApiHandler<AddToCartParameter, CartLineModel>;

export const PopulateApiParameter: HandlerType = props => {
    throwErrorIfTesting();

    props.apiParameter = props.parameter;
};

export const DispatchBeginAddingProductToCart: HandlerType = props => {
    props.dispatch({
        type: "Context/BeginUpdatingCart",
    });
};

export const SendDataToApi: HandlerType = async props => {
    const result = await addQuoteWithResult(props.apiParameter);

    if (result.successful) {
        props.apiResult = result.result;
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const DispatchCompleteAddingProductToCart: HandlerType = props => {
    props.dispatch({
        type: "Context/CompleteUpdatingCart",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginAddingProductToCart,
    SendDataToApi,
    DispatchCompleteAddingProductToCart,
    ExecuteOnSuccessCallback,
];

const quoteAddToCart = createHandlerChainRunner(chain, "QuoteAddToCart");
export default quoteAddToCart;
